// removed by extract-text-webpack-plugin
module.exports = {"contactsContainer":"_2Vnj09vvdtCb29032KAJp5","hideText":"_1gZHLHmAdx7tYfeYFdGkMW","textRevealed":"kCFVnwFGPgDM8ogrxAall","scrollContactButton":"_2_pYjTCQH0Dih7_MIy4pnW","scrollButton":"_1YiDjRX5iU2bes8fFaeixz","phone":"_3JL8zUAGiqxUCvyOnXt6uN","logoTitle":"_3B30MRXy3jXTf-SmB2fvQO","message":"_3ms4oKhJX0POmYc1VESJLx"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ProjectDetailedInfo/Contacts/Contacts.scss
// module id = 1696
// module chunks = 0